import React from 'react';
import ReactDOM from 'react-dom/client';
import { TimezoneProvider, TermsProvider, PORTAL_TERMS } from '@kioskgaming/ui';
import './index.css';
import App from './App';
import { ENV } from './config/env';
import { registerServiceWorker } from './serviceWorkerRegistration';

document.title = ENV.APP_NAME;

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <TimezoneProvider>
      <TermsProvider value={PORTAL_TERMS}>
        <App />
      </TermsProvider>
    </TimezoneProvider>
  </React.StrictMode>
);

registerServiceWorker();
